import { FC } from 'react';
import cn from 'bem-cn';

import { getAvatarSrc } from '../../../contexts/UserContext/UserContext.helpers';

import { getUserProfileLink } from '../../../utils/url';
import { Stack, ScoreBadge, Link } from '../../UI';
import { Rank } from './Rank';

import { LeaderboardItemProps } from './LeaderboardItem.types';
import './LeaderboardItem.scss';

const b = cn('leaderboard-item');

export const LeaderboardItem: FC<LeaderboardItemProps> = ({ leader, isCurrentUser }) => {
    const userContent = (
        <>
            <img src={leader.image || getAvatarSrc()} alt="" className={b('avatar')} />
            <span className={b('name')}>{leader.name ?? 'Промптхабер'}</span>
        </>
    );

    return (
        <Stack
            spacing={8}
            direction="row"
            alignItems="center"
            className={b()}
            id={isCurrentUser ? 'leaderboard-user-item' : undefined}
        >
            <Rank rank={leader.rank + 1} />
            {leader.publicId && !isCurrentUser ? (
                <Link className={b('user')} to={getUserProfileLink(leader.publicId)}>
                    {userContent}
                </Link>
            ) : (
                <div className={b('user')}>{userContent}</div>
            )}
            <span className={b('prefix')}>ИИндекс:</span>
            <ScoreBadge size="large" score={leader.score} className={b('score-badge')} />
        </Stack>
    );
};
